// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentLogos {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    max-width: 80%;
}
.contentLogos .logoExp {
    background-color: #f7f7f7;
    display: grid;
    place-content: center;
    border-radius: 0.5rem;
    box-shadow: 0px 0px 100px rgba(0, 0, 0, 0.07);
    width: 200px;
    flex: 30%;
    height: 80px;
}

.logoExp > svg {
    height: 30px;
}
@media (max-width: 769px) {
    .contentLogos {
        flex-wrap: wrap;
        margin: 0 2rem;
    }
    .contentLogos .logoExp {
        flex: 40%;
        height: 40px;
        width: 100px;
    }
    .contentLogos .logoExp > svg {
        height: 15px;
    }
}

.contentCard.typeC {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin: 2rem 0 3rem 0;
    max-width: 75rem;
}
.contentCard.typeC .card {
    background-color: #FFF;
    border-radius: 1rem;
    padding: 1.5rem 2.5rem;
    color: #000;
    min-height: 17rem;
    display: flex;
    flex-direction: column;
}
.contentCard.typeC .quote {
    font-size: 2.5rem;
}
.contentCard.typeC .boxUser {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: auto;
}
.contentCard.typeC .boxUser .foto {
    flex: none;
    width: 3rem;
    overflow: hidden;
    border-radius: 100px;
    display: flex;
}
.contentCard.typeC .boxUser .user {
    display: flex;
    flex-direction: column;
}
@media (max-width: 769px) {
    .contentCard.typeC {
        grid-template-columns: 1fr;
        gap: 1.5rem;
        margin: 2rem 0;
    }
    .contentCard.typeC .card {
        min-height: inherit;
        font-size: 0.875rem;
        line-height: 1.125rem;
    }
    .contentCard.typeC .boxTitle {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
    .contentCard.typeC .grafic {
        width: 60px;
        margin: 0;
    }
    .contentCard.typeC .title {
        font-size: 1.125rem;
        margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./js/pages/Homepage/Main/TrustTheExperts/TrustTheExperts.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,qBAAqB;IACrB,qBAAqB;IACrB,6CAA6C;IAC7C,YAAY;IACZ,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,SAAS;QACT,YAAY;QACZ,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI;QACI,0BAA0B;QAC1B,WAAW;QACX,cAAc;IAClB;IACA;QACI,mBAAmB;QACnB,mBAAmB;QACnB,qBAAqB;IACzB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,SAAS;IACb;IACA;QACI,WAAW;QACX,SAAS;IACb;IACA;QACI,mBAAmB;QACnB,SAAS;IACb;AACJ","sourcesContent":[".contentLogos {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n    max-width: 80%;\n}\n.contentLogos .logoExp {\n    background-color: #f7f7f7;\n    display: grid;\n    place-content: center;\n    border-radius: 0.5rem;\n    box-shadow: 0px 0px 100px rgba(0, 0, 0, 0.07);\n    width: 200px;\n    flex: 30%;\n    height: 80px;\n}\n\n.logoExp > svg {\n    height: 30px;\n}\n@media (max-width: 769px) {\n    .contentLogos {\n        flex-wrap: wrap;\n        margin: 0 2rem;\n    }\n    .contentLogos .logoExp {\n        flex: 40%;\n        height: 40px;\n        width: 100px;\n    }\n    .contentLogos .logoExp > svg {\n        height: 15px;\n    }\n}\n\n.contentCard.typeC {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    margin: 2rem 0 3rem 0;\n    max-width: 75rem;\n}\n.contentCard.typeC .card {\n    background-color: #FFF;\n    border-radius: 1rem;\n    padding: 1.5rem 2.5rem;\n    color: #000;\n    min-height: 17rem;\n    display: flex;\n    flex-direction: column;\n}\n.contentCard.typeC .quote {\n    font-size: 2.5rem;\n}\n.contentCard.typeC .boxUser {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-top: auto;\n}\n.contentCard.typeC .boxUser .foto {\n    flex: none;\n    width: 3rem;\n    overflow: hidden;\n    border-radius: 100px;\n    display: flex;\n}\n.contentCard.typeC .boxUser .user {\n    display: flex;\n    flex-direction: column;\n}\n@media (max-width: 769px) {\n    .contentCard.typeC {\n        grid-template-columns: 1fr;\n        gap: 1.5rem;\n        margin: 2rem 0;\n    }\n    .contentCard.typeC .card {\n        min-height: inherit;\n        font-size: 0.875rem;\n        line-height: 1.125rem;\n    }\n    .contentCard.typeC .boxTitle {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n    }\n    .contentCard.typeC .grafic {\n        width: 60px;\n        margin: 0;\n    }\n    .contentCard.typeC .title {\n        font-size: 1.125rem;\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
